// before 20-5-2026
// import React from 'react';
// import { Bar } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from 'chart.js';

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// export const SalesForTeamLeaderCard = ({ salesdata }) => {
//   const stages = salesdata.stages || [];

//   const chartLabels = stages.map((stage) => stage.stageName);
//   const chartData = stages.map((stage) => stage.count);

//   const maxValue = Math.max(...chartData);

//   const barData = {
//     labels: chartLabels,
//     datasets: [
//       {
//         label: 'Leads',
//         data: chartData,
//         backgroundColor: chartData.map((value) =>
//           value === maxValue ? '#102dff' : 'rgba(189, 198, 203, 0.5)',
//         ),
//         borderRadius: 20, // يجعل الأعمدة دائرية من الأعلى
//         barThickness: 40, // سماكة العمود
//       },
//     ],
//   };

//   const barOptions = {
//     responsive: true,
//     plugins: {
//       legend: { display: false },
//       title: {
//         display: false, // إخفاء العنوان لو مش محتاجه
//       },
//     },
//     scales: {
//       x: {
//         ticks: {
//           maxRotation: 45,
//           minRotation: 45,
//           color: '#555',
//           font: { size: 12 },
//         },
//         grid: {
//           display: false, // إخفاء خطوط المحور الأفقي
//           drawTicks: false,
//         },
//       },
//       y: {
//         beginAtZero: true,
//         ticks: {
//           stepSize: 4,
//           color: '#999',
//         },
//         grid: {
//           display: false, // إخفاء خطوط المحور الرأسي
//           drawTicks: false,
//         },
//       },
//     },
//   };

//   return (
//     <div
//       style={{
//         background: '#fff',
//         borderRadius: '16px',
//         boxShadow: '0 6px 16px rgba(0,0,0,0.08)',
//         padding: '25px',
//         margin: '15px',
//         width: '100%',
//         maxWidth: '420px',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//       }}
//     >
//       <div>
//         <h2 style={{ color: '#1e88e5', marginBottom: '10px' }}>{salesdata.salesName}</h2>
//         <p style={{ color: '#555', fontSize: '15px', marginBottom: '20px' }}>
//           <strong>Total Leads:</strong> {salesdata.totalLeads}
//         </p>

//         <div style={{ height: '300px', marginBottom: '25px' }}>
//           <Bar data={barData} options={barOptions} />
//         </div>

//         <div>
//           {stages.map((stage) => (
//             <div key={stage.stageName} style={{ marginBottom: '20px' }}>
//               <h4 style={{ color: '#333', marginBottom: '8px' }}>
//                 {stage.stageName} ({stage.count})
//               </h4>
//               <ul style={{ paddingLeft: '18px', color: '#444', fontSize: '14px' }}>
//                 {stage.leads.map((lead) => (
//                   <li key={lead._id} style={{ marginBottom: '6px' }}>
//                     <strong>{lead.name}</strong> - {lead.email} - {lead.phone}
//                     <br />
//                     <span style={{ color: '#777' }}>
//                       Project: {lead.project?.name || 'N/A'} | Developer:{' '}
//                       {lead.project?.developer?.name || 'N/A'}
//                     </span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };





import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid,
  Tooltip as ReTooltip, ResponsiveContainer,
} from 'recharts';

/* ─── Tokens ─────────────────────────────────────────────────────────────── */
const C = {
  white:      '#FFFFFF',
  border:     '#E8EAF0',
  accent:     '#0D47A1',
  accentDark: '#0a3880',
  accentSoft: 'rgba(13,71,161,0.08)',
  text:       '#1C2340',
  textMuted:  '#7B829A',
  warning:    '#F79009',
  shadow:     '0 1px 3px rgba(16,24,40,0.08)',
  shadowMd:   '0 6px 20px rgba(16,24,40,0.10)',
};

const STAGE_COLORS = [
  '#0D47A1','#1565C0','#1976D2','#42A5F5','#0891B2',
  '#F79009','#12B76A','#F04438','#8B5CF6','#06B6D4',
];

/* ─── Custom Chart Tooltip ───────────────────────────────────────────────── */
const ChartTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 10, padding: '10px 14px', boxShadow: '0 4px 16px rgba(0,0,0,0.1)', fontFamily: "'DM Sans',sans-serif" }}>
      <p style={{ margin: '0 0 3px', fontSize: 10, fontWeight: 700, color: C.textMuted, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{label}</p>
      <p style={{ margin: 0, fontSize: 16, fontWeight: 800, color: C.accent }}>
        {payload[0]?.value} <span style={{ fontSize: 11, fontWeight: 500, color: C.textMuted }}>leads</span>
      </p>
    </div>
  );
};

/* ─── Lead row (inside modal) ────────────────────────────────────────────── */
const LeadRow = ({ lead, color }) => (
  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '11px 14px', borderRadius: 10, background: '#FAFBFD', border: `1px solid ${C.border}`, marginBottom: 8, fontFamily: "'DM Sans',sans-serif" }}>
    <div style={{ width: 32, height: 32, borderRadius: '50%', background: `${color}18`, color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, flexShrink: 0 }}>
      {(lead.name || '?').split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)}
    </div>
    <div style={{ minWidth: 0, flex: 1 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: C.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{lead.name || '—'}</div>
      <div style={{ fontSize: 11, color: C.textMuted, marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {[lead.phone, lead.email].filter(Boolean).join(' · ')}
      </div>
      {(lead.project?.name || lead.project?.developer?.name) && (
        <div style={{ fontSize: 11, color: C.textMuted, marginTop: 3, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {lead.project?.name          && <span>📦 {lead.project.name}</span>}
          {lead.project?.developer?.name && <span>🏗 {lead.project.developer.name}</span>}
        </div>
      )}
    </div>
  </div>
);

/* ─── Stage Leads Modal (via portal) ─────────────────────────────────────── */
const StageModal = ({ stage, color, salesName, onClose }) => {
  const [search, setSearch] = useState('');
  if (!stage) return null;

  const leads = stage.leads || [];
  const filtered = leads.filter(l =>
    !search || l.name?.toLowerCase().includes(search.toLowerCase()) ||
    l.phone?.includes(search) || l.email?.toLowerCase().includes(search.toLowerCase())
  );

  return createPortal(
    <div
      style={{ position: 'fixed', inset: 0, zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(8px)', padding: 20, fontFamily: "'DM Sans',sans-serif", animation: 'pm-fade 0.2s ease both' }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{ background: '#F7F8FC', borderRadius: 20, width: '100%', maxWidth: 560, maxHeight: '88vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 32px 80px rgba(0,0,0,0.22)', border: `1px solid ${C.border}`, animation: 'pm-slide 0.26s cubic-bezier(0.34,1.1,0.64,1) both' }}>

        {/* Modal header */}
        <div style={{ background: C.white, padding: '18px 22px 16px', borderBottom: `1px solid ${C.border}`, flexShrink: 0, display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: `${color}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <div style={{ width: 10, height: 10, borderRadius: 3, background: color }} />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: C.textMuted, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 2 }}>{salesName}</div>
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800, color: C.text, letterSpacing: '-0.2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{stage.stageName}</h3>
          </div>
          <div style={{ flexShrink: 0, background: color, color: '#fff', borderRadius: 20, padding: '4px 12px', fontSize: 13, fontWeight: 700 }}>
            {leads.length} lead{leads.length !== 1 ? 's' : ''}
          </div>
          <button onClick={onClose} style={{ width: 30, height: 30, borderRadius: 8, border: `1.5px solid ${C.border}`, background: '#F7F8FC', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.textMuted, flexShrink: 0 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        {/* Search */}
        {leads.length > 3 && (
          <div style={{ padding: '10px 16px', borderBottom: `1px solid ${C.border}`, background: C.white, flexShrink: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={C.textMuted} strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
            <input
              autoFocus
              placeholder="Search leads…"
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ border: 'none', background: 'none', outline: 'none', fontSize: 13, color: C.text, fontFamily: "'DM Sans',sans-serif", width: '100%' }}
            />
            {search && <button onClick={() => setSearch('')} style={{ border: 'none', background: 'none', cursor: 'pointer', color: C.textMuted, fontSize: 14 }}>✕</button>}
          </div>
        )}

        {/* Leads list */}
        <div style={{ flex: 1, overflowY: 'auto', padding: 16, scrollbarWidth: 'thin', scrollbarColor: `${C.border} transparent` }}>
          {filtered.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 20px', color: C.textMuted, fontSize: 13 }}>
              {search ? `No leads matching "${search}"` : 'No leads in this stage.'}
            </div>
          ) : filtered.map(lead => <LeadRow key={lead._id} lead={lead} color={color} />)}
        </div>

        {/* Footer */}
        <div style={{ padding: '12px 20px', borderTop: `1px solid ${C.border}`, background: C.white, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <span style={{ fontSize: 12, color: C.textMuted }}>
            {filtered.length < leads.length ? `${filtered.length} of ${leads.length} leads` : `${leads.length} lead${leads.length !== 1 ? 's' : ''}`}
          </span>
          <button onClick={onClose} style={{ padding: '8px 20px', borderRadius: 9, border: 'none', background: C.accent, color: '#fff', fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

/* ════════════════════════════════════════════════════════════════════════════
   CARD
════════════════════════════════════════════════════════════════════════════ */
export const SalesForTeamLeaderCard = ({ salesdata }) => {
  const [modalStage, setModalStage] = useState(null); // { stage obj, color }

  const stages   = salesdata.stages || [];
  const maxCount = Math.max(...stages.map(s => s.count), 0);
  const total    = salesdata.totalLeads || stages.reduce((s, st) => s + st.count, 0);

  /* area chart data */
  const chartData = stages.map((s, i) => ({
    name:  s.stageName.length > 10 ? s.stageName.slice(0, 10) + '…' : s.stageName,
    full:  s.stageName,
    leads: s.count,
  }));

  const css = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');
    @keyframes pm-fade  { from{opacity:0} to{opacity:1} }
    @keyframes pm-slide { from{opacity:0;transform:translateY(18px) scale(0.97)} to{opacity:1;transform:none} }
    .tl-stage-pill:hover { border-color: var(--pill-color) !important; background: color-mix(in srgb, var(--pill-color) 12%, white) !important; transform: translateX(2px); }
  `;

  return (
    <>
      <style>{css}</style>

      <div style={{ background: C.white, borderRadius: 16, border: `1px solid ${C.border}`, boxShadow: C.shadowMd, overflow: 'hidden', display: 'flex', flexDirection: 'column', fontFamily: "'DM Sans',sans-serif" }}>

        {/* ── Header ── */}
        <div style={{ padding: '18px 20px 14px', borderBottom: `1px solid ${C.border}` }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 44, height: 44, borderRadius: 12, background: C.accentSoft, color: C.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 800, flexShrink: 0 }}>
              {(salesdata.salesName || '?').split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)}
            </div>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 800, color: C.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{salesdata.salesName}</div>
              <div style={{ fontSize: 11, color: C.textMuted, marginTop: 2 }}>{stages.length} stages</div>
            </div>
            <div style={{ flexShrink: 0, background: C.accent, color: '#fff', borderRadius: 20, padding: '4px 12px', fontSize: 13, fontWeight: 700 }}>
              {total} lead{total !== 1 ? 's' : ''}
            </div>
          </div>
        </div>

        {/* ── Area Line Chart ── */}
        {chartData.length > 0 && (
          <div style={{ padding: '16px 10px 8px' }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: C.textMuted, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 10, paddingLeft: 8 }}>Stage Trend</div>
            <ResponsiveContainer width="100%" height={160}>
              <AreaChart data={chartData} margin={{ top: 10, right: 10, left: -20, bottom: 36 }}>
                <defs>
                  <linearGradient id={`grad-${salesdata.salesID || 'x'}`} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%"  stopColor={C.accent} stopOpacity={0.25} />
                    <stop offset="95%" stopColor={C.accent} stopOpacity={0} />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#F0F2F8" vertical={false} />
                <XAxis
                  dataKey="name"
                  tick={{ fontSize: 9, fill: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}
                  axisLine={false} tickLine={false}
                  angle={-30} textAnchor="end" height={44} interval={0}
                />
                <YAxis tick={{ fontSize: 9, fill: C.textMuted, fontFamily: "'DM Sans',sans-serif" }} axisLine={false} tickLine={false} allowDecimals={false} />
                <ReTooltip content={<ChartTooltip />} />
                <Area
                  type="monotone"
                  dataKey="leads"
                  stroke={C.accent}
                  strokeWidth={2.5}
                  fill={`url(#grad-${salesdata.salesID || 'x'})`}
                  dot={{ fill: C.accent, r: 4, strokeWidth: 0 }}
                  activeDot={{ r: 6, strokeWidth: 0, fill: C.warning }}
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        )}

        {/* ── Stage pills — click opens modal ── */}
        <div style={{ padding: '10px 16px 18px', borderTop: `1px solid ${C.border}` }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: C.textMuted, letterSpacing: '0.08em', textTransform: 'uppercase', margin: '6px 0 10px' }}>Leads by Stage</div>

          {stages.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '16px 0', color: C.textMuted, fontSize: 13 }}>No stage data</div>
          ) : stages.map((stage, i) => {
            const color = stage.count === maxCount && stage.count > 0 ? C.warning : STAGE_COLORS[i % STAGE_COLORS.length];
            const pct   = total > 0 ? Math.round((stage.count / total) * 100) : 0;
            const hasLeads = stage.leads?.length > 0;

            return (
              <div
                key={stage.stageName}
                className="tl-stage-pill"
                onClick={() => hasLeads && setModalStage({ stage, color })}
                style={{
                  '--pill-color': color,
                  display: 'flex', alignItems: 'center', gap: 10,
                  padding: '9px 12px', borderRadius: 9, marginBottom: 6,
                  background: '#FAFBFD', border: `1.5px solid ${C.border}`,
                  cursor: hasLeads ? 'pointer' : 'default',
                  transition: 'all 0.15s',
                  position: 'relative', overflow: 'hidden',
                }}
              >
                {/* color bar left */}
                <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 3, background: color, borderRadius: '9px 0 0 9px' }} />
                <div style={{ width: 8, height: 8, borderRadius: 2, background: color, flexShrink: 0, marginLeft: 6 }} />
                <span style={{ fontSize: 12, fontWeight: 600, color: C.text, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{stage.stageName}</span>
                <span style={{ fontSize: 14, fontWeight: 800, color }}>{stage.count}</span>
                <span style={{ fontSize: 10, color: C.textMuted, minWidth: 32, textAlign: 'right' }}>({pct}%)</span>
                {hasLeads && (
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={C.textMuted} strokeWidth="2.5" style={{ flexShrink: 0 }}>
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* ── Stage Modal ── */}
      {modalStage && (
        <StageModal
          stage={modalStage.stage}
          color={modalStage.color}
          salesName={salesdata.salesName}
          onClose={() => setModalStage(null)}
        />
      )}
    </>
  );
};
